import { scopedThreadKey } from "@t3tools/client-runtime/environment";
import type { ScopedThreadRef } from "@t3tools/contracts";

import type { DraftId } from "../composerDraftStore";

export function composerSubmitTargetKey(target: ScopedThreadRef | DraftId): string {
  return typeof target === "string" ? target : scopedThreadKey(target);
}

let pendingSubmitTargetKey: string | null = null;

/** Ask ChatView to submit the composer once the target thread's composer is mounted. */
export function requestComposerSubmitOnMount(target: ScopedThreadRef | DraftId): void {
  pendingSubmitTargetKey = composerSubmitTargetKey(target);
}

export function consumeComposerSubmitRequest(target: ScopedThreadRef | DraftId): boolean {
  const key = composerSubmitTargetKey(target);
  if (pendingSubmitTargetKey !== key) {
    return false;
  }
  pendingSubmitTargetKey = null;
  return true;
}
